'use client'

import React, { useEffect } from 'react'
import './Frase_Day.css'
import { signosInfo } from '../../common/constants/signos'
import { useAppDispatch, useAppSelector } from '../../infrastructure/redux/hooks.ts'
import { fetchPhaseday } from '../../application/usecases/fetchPhaseday.ts'

const FraseDay = ({ sign1 }) => {
  const dispatch = useAppDispatch()
  const lowerSign = sign1.toLowerCase()

  const { data, loading, error } = useAppSelector((state) => state.phaseday)

  useEffect(() => {
    dispatch(fetchPhaseday(lowerSign))
  }, [dispatch, lowerSign])

  const signData = signosInfo[lowerSign] || {}

  return (
    <div className="container_group_frase">
      <div className="card-frase">
        <div className="container-text-frase">
          <div className="container-image-frase">
            <div className="container-header-frase">
              <img alt={`logo ${sign1}`} src={signData.img || "/images/default.png"} />
              <span>{sign1}</span>
            </div>
            <div className="text-frase">
              <h3 className="title-frase-description">Frase del día</h3>

              {loading && <p>Cargando frase...</p>}

              {error && <p>Error al cargar frase: {error}</p>}

              {!loading && !error && (
                <p className="custom-long-frase">
                  <em>
                    <strong>{sign1}</strong>, {data?.descripcion || 'Finding.'}
                  </em>
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FraseDay
